
import styled from 'styled-components';
import { whiteColor } from '../../styles/variables'
import { tablet } from '../../styles/mediaqueries'

const getErrorWindow = ({ isFullScreen }) => {
  let position = "fixed"
  let paddingDesktop = "0"
  let paddingTablet = "0"
  let backgroundColor = "rgba(45,46,44, 0.3)"




  if (isFullScreen) {
    position = "relative";
    backgroundColor = "white";
    paddingDesktop = "200px 0"
    paddingTablet = "100px 0"

  }

  return {
    position,
    backgroundColor,
    top: 0,
    padding: paddingDesktop,
    zIndex: 110,
    width: "100%",
    height: "100%",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [tablet]: {
      alignItems: 'flex-start',
      padding: paddingTablet
    },

  }
}

const getErrorContainer = () => {
  return {
    width: "615px",
    backgroundColor: whiteColor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: '100px 0',

    [tablet]: {
      width: '100%'
    },
  }
}

const getIconContainer = () => {
  return {
    position: "absolute",
    top: '20px',
    right: '20px',

    'svg': {
      cursor: 'pointer',
      width: '13px',
      height: '13px',
      fill: '#2D2E2C'
    }
  }
}

export const StyledIconContainer = styled.div(getIconContainer)
export const StyledErrorWindow = styled.div(getErrorWindow);
export const StyledErrorContainer = styled.div(getErrorContainer);



